import React from "react";
import styled from "styled-components";
import { theme } from "../theme";
import Button from "../components/Button";

const Screen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 100vh;
  padding: 32px;
  background: ${theme.colors.bg};
  font-family: ${theme.fonts.body};
  text-align: center;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: ${theme.colors.text};
`;

const Message = styled.p`
  max-width: 520px;
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: ${theme.colors.textSecondary};
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
`;

export const AuthLoading = ({ message = "Проверка авторизации..." }) => (
  <Screen>
    <Message>{message}</Message>
  </Screen>
);

export const NoAccess = () => (
  <Screen>
    <Title>Нет доступа</Title>
    <Message>
      Вы вошли в систему, но у вашей учётной записи нет роли для доступа к
      административной панели. Обратитесь к администратору.
    </Message>
  </Screen>
);

export const AuthError = ({ onRetry }) => (
  <Screen>
    <Title>Не удалось подключиться к Keycloak</Title>
    <Message>
      Сервер авторизации недоступен или не отвечает. Проверьте подключение и
      попробуйте ещё раз.
    </Message>
    <Actions>
      <Button $variant="primary" onClick={onRetry}>
        Повторить
      </Button>
    </Actions>
  </Screen>
);

export default AuthLoading;
